<template>
  <div class="doll-root" :class="{ mini: mini, ongoing: scanOngoing }">
    <fill-button
      v-if="showBubbles"
      v-show="!showClenchHint"
      class="fill-btn relative"
      is-left
      :action="bubbleActions[0]"
      :hit="isLeftHit"
      :mini="mini"
      :breathing="leftBreathing"
      @click="$emit('left-click')"
      @active="$emit('left-active')"
    />
    <fill-button
      v-if="showBubbles"
      v-show="!showClenchHint"
      class="fill-btn relative"
      :action="bubbleActions[1]"
      :hit="isRightHit"
      :mini="mini"
      :breathing="rightBreathing"
      @click="$emit('right-click')"
      @active="$emit('right-active')"
    />
    <img
      class="arm left-arm absolute"
      :style="leftArmStyles"
      src="../../assets/Doll/left-arm.svg"
    />
    <img
      class="arm right-arm absolute"
      :style="rightArmStyles"
      src="../../assets/Doll/right-arm.svg"
    />
    <img src="../../assets/Doll/doll.svg" class="absolute" />
    <clench v-if="showClenchHint" @ended="onClenchEnded" />
  </div>
</template>

<script>
import doll from '@/mixins/doll';

import Clench from '@/components/Animations/Clench.vue';
import FillButton from './FillButton.vue';

export default {
  name: 'Doll',
  components: {
    FillButton,
    Clench,
  },
  mixins: [doll],
  data: () => ({
    useClenchAnimation: true,
  }),
  computed: {
    armRotationBase() {
      return 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin mini {
  @apply mx-auto;
  transform: scale(0.6);
  min-height: 290px;
  max-height: 290px;
  .arm {
    top: -3%;
  }
  .animation {
    top: 9%;
  }
}
%mini {
  @include mini;
}
.doll-root {
  @apply relative flex justify-center items-center my-auto;
  width: 50%;
  max-width: 193px;
  min-width: 193px;
  height: 100%;
  max-height: 505px;
  min-height: 505px;
  &.mini {
    @extend %mini;
  }
  &.ongoing {
    opacity: 0.2;
  }
  @screen xs {
    @include mini;
    .animation {
      top: 21%;
    }
  }
}
.fill-btn {
  margin-top: 30%;
}
.arm {
  width: 40%;
  top: 19.5%;
}
.left-arm {
  left: -4%;
  transform-origin: 92% 12%;
}
.right-arm {
  right: -6.5%;
  transform-origin: 10% 12%;
}
</style>
